import { DocsExamples } from "@/types/docs-reference";

import primary from "./primary.mml";

export const examples: DocsExamples = {
  primary: {
    title: "Basic m-attr-anim",
    description: "This is a basic m-attr-anim.",
    code: primary,
  },
};
